import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { SendFrom, type SendFromStore } from 'widgets/SendFrom'
import styles from './styles.module.scss'

type IConversationChooseNumberProps = {
  sendFromStore: SendFromStore
}

export const ConversationChooseNumber: FC<IConversationChooseNumberProps> = observer(
  ({ sendFromStore: sendFromStore }) => {
    return (
      <div className={styles.wrap}>
        <div className={styles.label}>From:</div>
        <div className={styles.dropdown}>
          <SendFrom store={sendFromStore} triggerVariant={'button'} tabIndex={0} />
        </div>
      </div>
    )
  }
)
